<div id="{{theme}}-app" class="{{theme}}-preview-step-dialog">
    <div mat-dialog-title>
        <div class="row">
            <div class="col-md-10">
                <!-- <h3>Step Preview</h3> -->
            </div>
            <div class="col-md-2">
                <span style="cursor: pointer;" class="fa fa-close action-icons float-right ml-auto" (click)="close()"></span>
            </div>
        </div>
    </div>
    <!-- <div mat-dialog-content> -->
        <div >
            <app-breadcrumb [isPreviewMode]="true"></app-breadcrumb>
        </div>
    <div class="text-center">
        <app-flow-information></app-flow-information>
    </div>
    <!-- </div> -->
</div>